'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _redux = require('redux');

var _socket = require('./socket');

var _chats = require('./chats');

var _discussions = require('./discussions');

var _messages = require('./messages');

var _user = require('./user');

/**
 *
 */
exports.default = {
	vtChat: (0, _redux.combineReducers)({
		socket: _socket.socket,
		chats: _chats.chats,
		discussions: _discussions.discussions,
		messages: _messages.messages,
		user: _user.user
	})
};